import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, TextField } from '@sauda/ui/kit';
import type { Branch } from '../../lib/types.js';

export interface BranchValues {
  name: string;
  area?: string;
  address?: string;
  phone?: string;
}

/** The details of a branch. Used to add one and to edit one, in a sheet. */
export function BranchForm({
  initial,
  busy,
  submitLabel,
  onSubmit,
}: {
  initial?: Branch;
  busy: boolean;
  submitLabel: string;
  onSubmit: (values: BranchValues) => void;
}) {
  const { t } = useTranslation();
  const [name, setName] = useState(initial?.name ?? '');
  const [area, setArea] = useState(initial?.area ?? '');
  const [address, setAddress] = useState(initial?.address ?? '');
  const [phone, setPhone] = useState(initial?.phone ?? '');
  const text = (value: string) => (value.trim() === '' ? {} : { value: value.trim() });
  return (
    <form
      className="form-stack"
      onSubmit={(e) => {
        e.preventDefault();
        if (name.trim() === '') return;
        onSubmit({
          name: name.trim(),
          ...(text(area).value === undefined ? {} : { area: area.trim() }),
          ...(text(address).value === undefined ? {} : { address: address.trim() }),
          ...(text(phone).value === undefined ? {} : { phone: phone.trim() }),
        });
      }}
    >
      <TextField
        label={t('branches.name')}
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />
      <TextField
        label={t('branches.area')}
        value={area}
        onChange={(e) => setArea(e.target.value)}
      />
      <TextField
        label={t('branches.address')}
        value={address}
        onChange={(e) => setAddress(e.target.value)}
      />
      <TextField
        label={t('branches.phone')}
        type="tel"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />
      <Button type="submit" size="lg" block loading={busy} disabled={name.trim() === ''}>
        {submitLabel}
      </Button>
    </form>
  );
}
